<template>
  <div class="vue-wrapper">
    <form autocomplete="off" @submit.prevent="handleSearchSubmit" style="width:100%; display: inline-flex; margin-left: 0.75rem;">
      <TheAutoCompleteInput
        containerClassName="no-class"
        name="Auksjon"
        maxlength="10"
        ref="auksjonInput"
        v-model.trim="form.Auksjon"
        :placeholder="'Velg auksjon'"
        :label="''"
        :onInputCallback="onAuksjonSearchInput"
        :onSelectCallback="onAuksjonSearchSelected"
        :debounce="750"
        :minquery="2"
        :disabled="isAuctionDisabled"
      >
        <div slot="item" slot-scope="props">
          <strong>{{props.item.Auksjon}}</strong>, {{props.item.Beskrivelse}}
          <span v-if="props.item.Auksjon_dato">
            ({{ props.item.Auksjon_dato | avantidate }})
          </span>
        </div>
      </TheAutoCompleteInput>
      <button v-if="!isFormDisabled" class="button small primary disabled">Søk</button>
      <button v-else type="submit" class="button small primary">Søk</button>
    </form>

    <span class="divider"></span>

    <ul class="button-group">
      <li>
        <span title="Organiser kolonner" class="button-container has-popover" :class="{'popover-active': colPopoverActive}">
          <span class="button action small glyph glyph-only" @click="toggleColPopover()">
            <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-table"></use></svg>
          </span>
          <span class="popover popover-has-header popover-has-footer sortable align-x-center align-y-bottom large">
            <div class="popover-header"><span class="title">Organiser kolonner</span></div>
            <div class="custom-scrollbar">
              <draggable tag="ul" handle=".handle" :value="selectedColumns" @change="onDragChange">
                <li v-for="(column, index) in selectedColumns" v-bind:key="index" :class="{'disabled': !column.selected, 'inactive': !column.selected}">
                  <TheSwitchInputPopoverDragable v-if="!column.readonly" v-model="column.selected" :label="column.name" labelTrue="" labelFalse="" :trueValue="true" :falseValue="false"/>
                </li>
              </draggable>
            </div>
            <div class="popover-footer">
              <span class="button primary transparent tiny" @click="resetColumns()">Tillbakestill</span>
              <span class="button primary tiny" @click="saveColumns()">Lagre</span>
            </div>
          </span>
        </span>
      </li>
      <li>
        <span title="Visningssvalg" class="button-container has-popover" id="table-thumbnails-popover" :class="{'popover-active': imgPopoverActive}">
          <span class="button action small glyph glyph-only" @click="toggleImgPopover()">
            <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-image"></use></svg>
          </span>
          <span class="popover popover-has-header radio align-x-center align-y-bottom medium">
            <div class="popover-header"><span class="title">Visningssvalg</span></div>
            <ul>
              <li v-for="(imagesize, index) in selectedImageSizes" v-bind:key="imagesize.key" :class="{'active': imagesize.selected}">
                <a href="javascript:;" @click="saveImageSizes(index, imagesize.key)">
                  <span class="radio-glyph"></span>
                  <span class="radio-title">{{imagesize.name}}</span>
                </a>
              </li>
            </ul>
          </span>
        </span>
      </li>
    </ul>

    <a href="javascript:;" @click="exportCsv()" title="Eksporter CSV" class="button action small glyph glyph-only">
      <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-spreadsheet"></use></svg>
    </a>
  </div>
</template>

<script>
import bus from '@/plugins/event-bus'
import draggable from 'vuedraggable'
import AuksjonService from '@/services/AuksjonService'
import TheAutoCompleteInput from '../../../Inputs/TheAutoCompleteInput'

const swapArrayElements = function (array, index1, index2) {
  array[index1] = array.splice(index2, 1, array[index1])[0]
  return array
}

export default {
  name: 'TheTelefonbudTopbar',
  components: {
    draggable,
    TheAutoCompleteInput
  },
  data () {
    return {
      colPopoverActive: false,
      imgPopoverActive: false,
      selectedColumns: [],
      selectedImageSizes: [],
      dropdowns: {
        auksjon: []
      },
      form: {
        Avdelingsid: 0,
        Auksjon: null
      }
    }
  },
  created () {
    // Remove popover on click outside...
    const vm = this

    window.jQuery(document).mouseup(function (e) {
      var container = window.jQuery('.has-popover')
      // if the target of the click isn't the container nor a descendant of the container
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        vm.colPopoverActive = false
        vm.imgPopoverActive = false
      }
    })

    // Add our model for selected columns
    this.selectedColumns = this._.cloneDeep(this.columns)
    this.selectedImageSizes = this._.cloneDeep(this.imagesizes)

    this.loadNextClassical()
  },
  computed: {
    imagesizes: function () {
      return this.$store.getters['telefonbud/imagesizes']
    },
    columns: function () {
      return this.$store.getters['telefonbud/columns']
    },
    isAuctionDisabled: function () {
      return this.form.Avdelingsid === '' || this.form.Avdelingsid === null
    },
    isFormDisabled: function () {
      return !!this.form.Auksjon
    }
  },
  watch: {
    'form.Avdelingsid': function (newVal) {
      if (newVal !== null && newVal !== undefined) {
        this.$refs['auksjonInput'].reload()
      }
    }
  },
  methods: {
    loadNextClassical: function () {
      bus.$emit('telefonbud-reset')

      AuksjonService.getNextClassical()
        .then(response => {
          if (response.data.Auksjon) {
            this.form.Auksjon = response.data.Auksjon
            this.handleSearchSubmit()
          }
        })
        .catch(error => {
          console.log('Error', error)
        })
    },
    onAuksjonSearchInput: function (query) {
      return AuksjonService.search(query, this.form.Avdelingsid)
    },
    onAuksjonSearchSelected: function (item) {
      this.form.Auksjon = item ? item.Auksjon : null
    },
    // See: https://github.com/SortableJS/Vue.Draggable
    onDragChange: function (event) {
      if (event.moved) {
        let x = event.moved.oldIndex
        let y = event.moved.newIndex

        // Update array, move and shift down or up...
        if (x > y) {
          for (let i = x; i > y; --i) {
            this.selectedColumns = swapArrayElements(this.selectedColumns, i, i - 1)
          }
        } else {
          for (let i = x; i < y; ++i) {
            this.selectedColumns = swapArrayElements(this.selectedColumns, i, i + 1)
          }
        }
      }
    },
    saveColumns: function () {
      this.$store.dispatch('telefonbud/saveColumns', this.selectedColumns)
        .then(() => {
          this.selectedColumns = this._.cloneDeep(this.columns)
          this.colPopoverActive = false

          bus.$emit('telefonbud-after-column-update')
        })
    },
    resetColumns: function () {
      this.$store.dispatch('telefonbud/resetColumns')
        .then(() => {
          this.selectedColumns = this._.cloneDeep(this.columns)
          this.colPopoverActive = false

          bus.$emit('telefonbud-after-column-update')
        })
    },
    saveImageSizes: function (index, key) {
      this.selectedImageSizes.forEach(element => {
        this.$set(element, 'selected', element.key === key)
      })

      this.$store.dispatch('telefonbud/saveImageSizes', this.selectedImageSizes)
        .then(() => {
          this.selectedImageSizes = this._.cloneDeep(this.imagesizes)
          this.imgPopoverActive = false

          bus.$emit('telefonbud-after-column-update')
        })
    },
    toggleColPopover: function () {
      if (!this.colPopoverActive) {
        this.colPopoverActive = true
        this.imgPopoverActive = false
      } else {
        this.colPopoverActive = false
        this.imgPopoverActive = false
      }
    },
    toggleImgPopover: function () {
      if (!this.imgPopoverActive) {
        this.imgPopoverActive = true
        this.colPopoverActive = false
      } else {
        this.imgPopoverActive = false
        this.colPopoverActive = false
      }
    },
    handleSearchSubmit: function () {
      bus.$emit('telefonbud-start', { code: this.form.Auksjon })
    },
    exportCsv: function () {
      bus.$emit('telefonbud-export')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/Auctions/Telefonbud/TheTopbar.vue